import { useIsAuth } from "modules/Auth/hooks";
import React, { useState, useRef, useEffect } from "react";
import { createPortal } from 'react-dom';

interface BottomUpDrawerWithTouchProps {
  isOpen: boolean;
  toggleDrawer: () => void;
  children?: React.ReactNode;
  title?: string;
  zIndex?: number;
}

const BottomUpDrawerWithTouch = ({
  isOpen,
  toggleDrawer,
  children,
  title,
  zIndex = 102,
}: BottomUpDrawerWithTouchProps) => {
  const [translateY, setTranslateY] = useState(100); // Initial state of translateY (hidden)
  const drawerRef = useRef<any>(null);
  const isAuth = useIsAuth();
  
  // const toggleDrawer = () => {
  //   setIsOpen(!isOpen);
  //   setTranslateY(0); // Reset to fully open when toggled
  // };

  useEffect(() => {
    console.log('init webViewCallGetListPath', (window as any).location?.pathname);
    if ((window as any).webViewCallGetListPath) {
      (window as any).webViewCallGetListPath([(window as any).location?.pathname])
    }
  }, [])


  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      if (!isAuth) {
        console.log('showed drawer');
        if (["android"].includes((window as any)._APP_PLATFORM.toLowerCase())) {
          (window as any).webViewRequestHasPopupMain('showed');
        }
      }
      
      // save old back function
      if (!(window as any).__backFromDeviceAndroid && (window as any).backFromDeviceAndroid) {
        (window as any).__backFromDeviceAndroid = (window as any).backFromDeviceAndroid;
      }
      (window as any).backFromDeviceAndroid = function () {
        toggleDrawer();
        // restore old back function
        (window as any).backFromDeviceAndroid = (window as any).__backFromDeviceAndroid
      };
    } else {
      if (!isAuth) {
        if (["android"].includes((window as any)._APP_PLATFORM.toLowerCase())) {
          (window as any).webViewRequestHasPopupMain('closed');
        }
      }
      
      document.body.style.overflow = '';
    }
    
    // Cleanup to reset the body overflow when the component unmounts
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleTouchStart = (e: any) => {
    drawerRef.current.touchStartY = e.touches[0].clientY;
  };

  const handleTouchMove = (e: any) => {
    const touchMoveY = e.touches[0].clientY;
    const diff = touchMoveY - drawerRef.current.touchStartY;
    
    if (diff > 0) {
      setTranslateY(diff); // Move the drawer down with the touch movement
    }
  };

  const handleTouchEnd = () => {
    // If the drawer has been dragged more than 50% of its height, close it
    if (translateY > 100) {
      // setIsOpen(false);
      toggleDrawer();
      setTranslateY(100); // Move it off-screen
    } else {
      setTranslateY(0); // Snap back to the open position
    }
  };

  return createPortal(
    <div className={`relative ${isOpen ? `min-h-screen z-${zIndex}` : 'h-0'}`}>
      {/* Drawer Overlay */}
      {isOpen && (
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 z-${zIndex}`}
          onClick={() => {
            toggleDrawer();
            setTranslateY(100); 
          }}
        ></div>
      )}

      {/* Bottom Drawer with Touch */}
      <div
        ref={drawerRef}
        className={`rounded-t-[16px] fixed bottom-0 left-0 w-full bg-white shadow-lg z-${zIndex} transform transition-transform duration-300`}
        style={{ transform: `translateY(${isOpen ? 0 : 100}%)` }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Drawer Header */}
        {title && <div className="flex justify-center items-center pt-[30px] pb-[20px]">
          <h2 className="text-[16px] font-medium">{title}</h2>
        </div>}

        {/* Drawer Body */}
        <div className="px-4 py-[30px]">
          {children}
        </div>
      </div>
    </div>,
    document.body
  )
}

export default BottomUpDrawerWithTouch;
